import { Order } from "pages/admin/Orders/Orders"
import React, { useEffect, useState } from "react"
import Select, { SingleValue } from "react-select"
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap"
import * as Yup from "yup"
import { useFormik } from "formik"
import { deliveryMenData } from "pages/admin/Delivery-men"
import FormLabel from "components/Extra/FormLabel"
import { FormInput } from "components/Extra/FormInput"
import { useTranslation } from "react-i18next"

interface AssignDeliveryManModalProps {
  order: Order | null
  isOpen: boolean
  toggle: () => void
  isAutoAssign?: boolean
}

export const AssignDeliveryManModal: React.FC<AssignDeliveryManModalProps> = ({
  isOpen,
  order,
  toggle,
  isAutoAssign = false,
}) => {
  const { t } = useTranslation()

  const [openAccordion, setOpenAccordion] = useState("0")
  const [selectedDeliveryMan, setselectedDeliveryMan] = useState<{
    value: string
    label: string
  } | null>(null)

  const validation = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    validateOnBlur: true,
    validateOnMount: true,
    initialValues: {
      note: "",
      deliveryMan: null,
    },
    validationSchema: Yup.object({
      // note: Yup.string().trim(),
      deliveryMan: Yup.object({
        id: Yup.string().required(t("orders_idValidationMessage") as string),
        name: Yup.string().required(
          t("orders_nameValidationMessage") as string
        ),
      }),
    }),
    onSubmit: ({ note, deliveryMan }) => {
      console.log({ note, deliveryMan })
      console.log(order)

      // TODO: Dispatch
      validation.resetForm()
      toggle()
    },
  })

  useEffect(() => {
    validation.resetForm()
    // Auto-select first delivery man if in auto-assign mode
    if (isAutoAssign && deliveryMenData.length > 0) {
      const firstDeliveryMan = {
        value: deliveryMenData[0].id,
        label: deliveryMenData[0].name,
      }
      setselectedDeliveryMan(firstDeliveryMan)
      validation.setFieldValue("deliveryMan", {
        id: firstDeliveryMan.value,
        name: firstDeliveryMan.label,
      })
    }
  }, [isOpen, isAutoAssign])

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle} tag="h3">
        <h4 className="text-capitalize fw-semibold font-size-24">
          {isAutoAssign ? t("common_autoAssignDeliveryMan") : t("orders_assignDeliveryMan")}
        </h4>
      </ModalHeader>
      <ModalBody>
        <Form
          onSubmit={e => {
            e.preventDefault()
            validation.handleSubmit()
            return false
          }}
        >
          <Accordion open={openAccordion}>
            <AccordionItem>
              <AccordionHeader
                targetId="0"
                onClick={() =>
                  setOpenAccordion(openAccordion === "0" ? "1" : "0")
                }
              >
                {t("common_respondInfo")}
              </AccordionHeader>
              <AccordionBody accordionId="0">
                <FormGroup>
                  <FormLabel htmlFor="deliveryMan" required>
                    {t("orders_deliveryMan")}
                  </FormLabel>
                  <Select
                    id="deliveryMan"
                    value={selectedDeliveryMan}
                    isDisabled={isAutoAssign}
                    onChange={(
                      selectedOption: SingleValue<{
                        value: string
                        label: string
                      }>
                    ) => {
                      setselectedDeliveryMan(selectedOption)
                      validation.setFieldValue("deliveryMan", {
                        id: selectedOption?.value,
                        name: selectedOption?.label,
                      })
                    }}
                    options={deliveryMenData.map(one => ({
                      value: one.id,
                      label: one.name,
                    }))}
                    className="select2-selection"
                  />
                  {validation.touched.note && validation.errors.note ? (
                    <FormFeedback type="invalid">
                      {validation.errors.note}
                    </FormFeedback>
                  ) : null}
                </FormGroup>
                <FormInput
                  label={t("orders_specific_note") as string}
                  name="note"
                  type="textarea"
                  placeholder={t("orders_enterMessage") as string}
                  validation={validation}
                  rows="3"
                />
              </AccordionBody>
            </AccordionItem>
          </Accordion>
          <Row>
            <Col>
              <div className="d-flex justify-content-end gap-2 mt-4">
                <button
                  type="submit"
                  className={`btn bg-gradiant-blue border-0 text-white save-customer`}
                  disabled={!(validation.isValid && validation.dirty)}
                >
                  {t("common_send")}
                </button>
                <button
                  onClick={toggle}
                  type="button"
                  className="btn btn-cancel text-cyan border border-cyan"
                >
                  {t("common_cancel")}
                </button>
              </div>
            </Col>
          </Row>
        </Form>
      </ModalBody>
    </Modal>
  )
}
